/**
 * Use this when you need update the payment status
 */
export const PAYMENT_STATUSES = [
  { value: 'payment_pending', text: 'Test received - payment pending' },
  { value: 'test_rejected', text: 'Test rejected' },
];

export const ALL_PAYMENT_STATUSES = {
  payment_pending: 'Test received - payment pending',
  paid: 'Paid',
  test_rejected: 'Test rejected',
  error: 'Error - contact participants@playbookux',
  did_not_show: 'No payment - you did not show',
};

export const PAYMENT_ENUMS = {
  pending: 'payment_pending',
  paid: 'paid',
  rejected: 'test_rejected',
  error: 'error',
  did_not_show: 'did_not_show',
};
